// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { SchemaModifier } from '../types';
import { generateSchema } from '../SchemaGeneration';

const researchFocusModifier: SchemaModifier = (
  content,
  main,
  parts,
  state,
  partial,
) => {
  if (content?.parent && content.parent['@type'] === 'ResearchArea') {
    main['isPartOf'] = generateSchema({
      type: content.parent['@type'],
      content: content.parent as Content,
      state,
      partial: true,
    });
  }
};

export default researchFocusModifier;
